export default __webpack_public_path__ + "static/media/Page7Background.c03fa46b.png";